{
  const sliderIndex = slider => {
    const cur = slider.querySelector('.slick-current')
    return cur ? parseInt(cur.getAttribute('data-slick-index'), 10) : 0
  }

  const link = (source, target) => {
    jQuery(source).on('afterChange', (e, slick, current) => {
      if (sliderIndex(target) !== current) target.goToSlide(current)
    })
  }

  window.addEventListener('load', () => {
    document.querySelectorAll('.panel-slider').forEach(block => {
      const images = block.querySelector('.panel-slider--images ada-slider')
      const content = block.querySelector('.panel-slider--panel ada-slider')
      if (!images || !content) return
      link(images, content)
      link(content, images)
    })
  })
}
